import axios from "@/utils/axios.js";

/**
 * Получение списка причин обмена/возврата
 */
function getReturnReasons(perPage, currentPage, sort, search) {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `return-reasons?expand=user&sort=${sort}${
          search ? `&search[All]=${search}` : ""
        }&per-page=${perPage}&page=${currentPage}`
      )
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

function getReturnReason(id) {
  return new Promise((resolve, reject) => {
    axios
      .get(`return-reasons/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

function createReturnReason(reason) {
  return new Promise((resolve, reject) => {
    axios
      .post("return-reasons", { name: reason })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

function updateReturnReason(id, reason) {
  return new Promise((resolve, reject) => {
    axios
      .put(`return-reasons/${id}`, { id: id, name: reason })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

function deleteReturnReasons(id) {
  return new Promise((resolve, reject) => {
    axios
      .delete(`return-reasons/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export {
  getReturnReasons,
  getReturnReason,
  createReturnReason,
  updateReturnReason,
  deleteReturnReasons,
};
